var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ai-chatbot"},[(_vm.displayChatbot && !_vm.isInline)?_c('ChatbotButton',{attrs:{"isChatbotOpen":_vm.isChatbotOpen}}):_vm._e(),_c('transition',{attrs:{"name":"fade"}},[(_vm.isChatbotOpen)?_c('ChatbotWindow',{on:{"close":_vm.closeChatbot}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }